import React from 'react';
import { yesNoOptions } from 'op-utils';
import { sharedContent } from '../../../shared/constants';
import { ReviewBox } from 'shared-components/components';
import { Question, Answer, QuestionContainer } from './ReviewSharedComponents';

interface Props {
  fields: any;
  values: any;
  error: boolean;
  link: string;
  isLocked: boolean;
}

const convertValueToLabel = (value: any, arrayLabel?: any) => {
  for (const option of arrayLabel) {
    if (option.value === value) return option.label;
  }
};

const renderQuestionRow = (item: string, fields: any, values: any): JSX.Element => {
  return (
    <QuestionContainer aria-label={`review-${fields[item]}`}>
      <Question value={values[item]}>{fields[item]}</Question>
      <Answer value={values[item]}>
        {values[item] !== null
          ? convertValueToLabel(values[item], yesNoOptions)
          : sharedContent.generic.label.notProvided}
      </Answer>
    </QuestionContainer>
  );
};
const ReviewACD = (props: Props): JSX.Element => {
  const { fields, values, error, link, isLocked } = props;

  return (
    <ReviewBox title={'Advance Care Directive/NFR'} error={error} link={link} isLocked={isLocked}>
      {renderQuestionRow('hasCurrentAcd', fields, values)}
      {!values.hasCurrentAcd && renderQuestionRow('acdInfoRequested', fields, values)}
      {renderQuestionRow('hasCurrentResusMxPlan', fields, values)}
    </ReviewBox>
  );
};

export default ReviewACD;
